// import jsonp from 'common/js/jsonp'
// import { commonParams, options } from './config'
import axios from 'axios'

// const debug = process.env.NODE_ENV !== 'production'

export function getRecommend() {
  const url = 'https://apiservices.kimy.com.tw/mag/api/getSliders'
  return axios.get(url).then(res => {
    // console.log('getSlider', res.data)
    return Promise.resolve(res.data)
  })
}

export function getDiscList() {
  const url = 'https://apiservices.kimy.com.tw/mag/api/getMaglist'
  return axios.get(url).then(res => {
    console.log('getDiscList=>', res.data)
    return Promise.resolve(res.data)
  })
}

export function getSongList(disstid) {
  const url = `https://apiservices.kimy.com.tw/mag/api/getCdList/${disstid}`
  return axios.get(url).then((res) => {
    return Promise.resolve(res.data)
  })
}

export function getAudioBook(bookid) {
  const url = `https://api.hsin-yi.org.tw/audiobook/${bookid}`
  return axios.get(url).then((res) => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/recommend.js